import styled from 'styled-components';
import {AutoComplete} from "@progress/kendo-react-dropdowns";

export const StyledAutoComplete = styled(AutoComplete)`
  &, &:focus-within, &:focus-within {
    width: 100%;
    border:0;
    box-shadow: none;
    border-radius:1.2rem;
    display: flex;
    align-items: center;
  }
  .k-clear-value{
    width: 3rem;
  }
`